import React, { useMemo } from 'react';
import {
  DataGrid,
  GridColDef,
  CellTypes,
  DataGridProps,
} from '@fashionnovateam/nova-ui-toolkit';
import { Link } from 'react-router-dom';
import numeral from 'numeral';

type Row = {
  id: number;
  date: CellTypes.DataGridCellDateTimeParams;
  reference_number: CellTypes.DataGridCellCustomParams;
  memo: CellTypes.DataGridCellStringParams;
  amount: CellTypes.DataGridCellStringParams;
};

const columns: GridColDef[] = [
  {
    field: 'date',
    headerName: 'Date',
    render: 'dateTime',
    display: 'flex',
    flex: 1,
    sortable: true,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    field: 'reference_number',
    headerName: 'Reference Number',
    render: 'custom',
    flex: 1,
    sortable: true,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    field: 'memo',
    headerName: 'Memo',
    display: 'flex',
    render: 'string',
    flex: 1,
    sortable: false,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    field: 'amount',
    display: 'flex',
    headerName: 'Amount',
    render: 'string',
    flex: 1,
    sortable: true,
    minWidth: 150,
    disableColumnMenu: true,
  },
];

type Props = {
  rows: any[];
} & Omit<DataGridProps<Row>, 'columns'>;

function BillCreditDataGrid({ rows, ...datagridProps }: Props) {
  const transformedRows = useMemo(
    () =>
      rows.map(
        (credit) =>
          ({
            id: credit.id,
            date: {
              activity: false,
              date: credit.date,
              time: false,
            },
            reference_number: (
              <Link
                to={`credits/${credit.internal_id}`}
                className="font-semibold underline text-primary-700"
              >
                {credit.reference_number}
              </Link>
            ),
            memo: credit.memo,
            amount: numeral(credit.amount).format('$0,0.00'),
          }) satisfies Row,
      ),
    [rows],
  );

  return (
    <DataGrid
      hideFilterButton
      hideGroupButton
      columns={columns}
      rows={transformedRows}
      initialState={{
        pinnedColumns: {
          left: ['date'],
        },
      }}
      sortingMode="server"
      paginationMode="server"
      {...datagridProps}
    />
  );
}

export default BillCreditDataGrid;
